export default "__VITE_ASSET__BiwLHMpQ__"